<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import 'swiper/dist/css/swiper.css'
  import { isObjectLike } from 'lodash'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
    name: 'OverlayGallery',
    components: {
      swiper,
      swiperSlide,
    },
    props: {
      isOpen: Boolean,
      swiperSlides: Array,
      overlayIndex: Number,
    },
    data() {
      return {
        activeIndex: 0,
        swiperOption: {
          init: false,
          slidesPerView: 1,
          autoHeight: true,
          watchOverflow: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          initialSlide: this.overlayIndex,
        },
      }
    },
    computed: {
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.isOpen
        },
      },
    },
    mounted() {
      this.$refs.swiper.swiper.init()
    },
    methods: {
      isImage(attachment) {
        return (
          (isObjectLike(attachment) && attachment.type.indexOf('image') > -1) ||
          (!isObjectLike(attachment) && attachment.match(/\.(jpeg|jpg|gif|png)$/) != null)
        )
      },
      getLink(attachment) {
        return isObjectLike(attachment) && attachment.link ? attachment.link : attachment
      },
    },
  }
</script>
